import { Bot } from "lucide-react";
import { usePaidLine } from "@/hooks/usePaidLine";
import { PaidLineNumber } from "@/components/PaidLineNumber";

export const PaidLineInfo = () => {
  const paidLine = usePaidLine();

  return (
    <div className="border border-border bg-[#0A0A0A] rounded-sm p-6 space-y-4">
      <div className="flex items-center gap-2">
        <Bot className="w-4 h-4 text-[#007AFF]" />
        <h2 className="font-heading text-lg font-black tracking-tight">How the paid line works</h2>
      </div>

      <PaidLineNumber paidLine={paidLine} size="lg" testIdPrefix="credits" />

      <ul className="text-xs text-muted-foreground space-y-2 leading-relaxed list-disc pl-4">
        <li>Calling this number has a fee — calls are enabled by the credits you purchase here.</li>
        <li>Your records always remain on this site unless you delete them; credits only pay for the calls.</li>
        <li>
          <span className="text-white font-medium">You'll be talking to a voice avatar</span> — an AI phone
          agent built on Vapi that answers instantly, sounds like a real person, asks the right follow-up
          questions, and files the structured report, transcript, and audio recording to your account.
        </li>
      </ul>
    </div>
  );
};
